//Inject data-src attribut datas in src attribut
var insertSrcAttrElImg = function( elt) {
    for( var i=0; i< elt.length; i++) {
        var dataSrc = elt[i].getAttribute('data-src');
        elt[i].setAttribute('src', dataSrc);
        elt[i].setAttribute('data-src', '');
    }
};

var scrollTopBtn = function( jQuery, btn) {
    if( window.matchMedia( "(max-width: 991px)").matches) {
        var scrollTopPage = function() {
            jQuery('html, body').animate({
                scrollTop: 0
            }, 600);
            return false;
        };
        setInterval( function() {
            var pos = window.pageYOffset;
            if( pos < 50) {
                btn.style.display = 'none';
            }
            else {
                btn.style.display = 'block';
            }
        }, 500);
        btn.addEventListener( 'click', scrollTopPage);
    }
};

// Detect Mobile Device
jQuery( document ).ready(function() {
    var isBrowserDevice = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    if ( isBrowserDevice ) {
        jQuery('.hideFromMobileJS').hide();
    }
});
